export function validateXpath(path: string): boolean {
    try {
        document.evaluate(path, document.body, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);

        return true;
    } catch (err) {
        console.error(err);
        return false;
    }
}

export const getWizardClassName = (str: string) => `wiz_${str}`;
